// extracted by mini-css-extract-plugin
export default {"canvas":"graph_canvas__SL+on","canvasBackground":"graph_canvasBackground__EuMCV","pointui":"graph_pointui__U0VgV"};